import { earliestVisibleWave } from '@context/dashboardFetchWave'
import { DashboardSection } from '@constants/Dashboard/dashboard.enums'

export type PerformanceSectionWaves = {
  production: number | null
  productionByProcedure: number | null
  collection: number | null
  arAging: number | null
  arOver90: number | null
  productionByDepartment: number | null
  clinicalEfficiency: number | null
  scheduling: number | null
  utilizationMetrics: number | null
  seatUtilization: number | null
  providerUtilization: number | null
  productionPerProvider: number | null
}

function show(section: DashboardSection, hiddenSections: Set<string>): boolean {
  return !hiddenSections.has(section)
}

export function buildPerformanceSectionWaves(
  hiddenSections: Set<string>,
): PerformanceSectionWaves {
  const visible = (section: DashboardSection): boolean =>
    show(section, hiddenSections)
  const procedureVisible = visible(DashboardSection.ProductionByProcedure)
  const utilizationVisible = visible(DashboardSection.UtilizationMetrics)
  return {
    production: procedureVisible ? 0 : null,
    productionByProcedure: procedureVisible ? 0 : null,
    collection: earliestVisibleWave([
      [
        visible(DashboardSection.CollectionMetric) ||
          visible(DashboardSection.CollectionRate),
        1,
      ],
      [
        visible(DashboardSection.DsoDaysToCollect) ||
          visible(DashboardSection.Collection),
        2,
      ],
    ]),
    arAging: visible(DashboardSection.ArAgingMetric) ? 1 : null,
    arOver90: visible(DashboardSection.ArOver90Day) ? 1 : null,
    productionByDepartment: visible(DashboardSection.ProductionByDepartment)
      ? 2
      : null,
    clinicalEfficiency: utilizationVisible ? 0 : null,
    scheduling: visible(DashboardSection.SchedulingPerformance) ? 0 : null,
    utilizationMetrics: utilizationVisible ? 1 : null,
    seatUtilization: visible(DashboardSection.SeatUtilization) ? 2 : null,
    providerUtilization: visible(DashboardSection.ProviderUtilization)
      ? 2
      : null,
    productionPerProvider: visible(DashboardSection.ProductionPerProvider)
      ? 2
      : null,
  }
}
